import {
  GridCellCheckboxRenderer,
  GridColumnHeaderParams,
  GridHeaderCheckbox,
  GridRenderCellParams,
  useTheme,
} from '@chronosphereio/chrono-ui';
import { LegendCheckboxProps } from './LegendCheckbox';
import { getLegendItemMarkerVariant, LegendItem } from './legend-model';

// Creating a recast version of the `GridCellCheckboxRenderer` to appease typescript.
const TableLegendGridCellCheckboxRenderer = GridCellCheckboxRenderer as React.ForwardRefExoticComponent<
  GridRenderCellParams<LegendItem> &
    React.RefAttributes<HTMLInputElement> &
    Pick<LegendCheckboxProps, 'color' | 'variant'>
>;

export const TableLegendCellCheckbox = (props: GridRenderCellParams<LegendItem>) => {
  // Passing extra props to a recast version of `GridCellCheckboxRenderer` to get the custom
  // legend colors and styling we need in our checkboxes and retain all the logic in the MUI code.
  // The underlying code clearly supports passing along additional props to the checkbox (ranging from
  // the version we're using up through master), so this seems relatively safe besides it being ugly.
  // If this ever breaks, we should catch it on visual tests when the colors stop being customized.
  // https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/components/columnSelection/GridCellCheckboxRenderer.tsx#L110
  // The alternative is to copy-paste the entire MUI component, adjust it to support the color
  // prop, and deal with nasty diffs whenever we upgrade MUI.
  return (
    <TableLegendGridCellCheckboxRenderer
      {...props}
      color={props.row.color}
      variant={getLegendItemMarkerVariant(props.row)}
    />
  );
};

// Creating a recast version of the `GridCellCheckboxRenderer` to appease typescript.
const TableLegendGridHeaderCheckbox = GridHeaderCheckbox as React.ForwardRefExoticComponent<
  GridColumnHeaderParams<LegendItem> & React.RefAttributes<HTMLInputElement> & Pick<LegendCheckboxProps, 'color'>
>;

export function TableLegendHeaderCheckbox(props: GridColumnHeaderParams<LegendItem>) {
  const { theme } = useTheme();
  return <TableLegendGridHeaderCheckbox {...props} color={theme.palette.text.primary} />;
}
